import AutoNumeric from "autonumeric";
import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    options: {
      type: Object,
      default: {},
    },
  };

  connect() {
    if (AutoNumeric.isManagedByAutoNumeric(this.element)) {
      return;
    }

    new AutoNumeric(this.element, this.optionsValue).set(this.element.value);
  }
}
